module.exports = __webpack_public_path__ + "img/5.8359b5c.svg";